// removed by extract-text-webpack-plugin
module.exports = {"ButtonsInside":"Build__ButtonsInside___2GY6l"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/build/Build.less
// module id = 1224
// module chunks = 0 1